import React from 'react';
import { observer } from 'mobx-react';

import star from 'four-nets/icons/svg/icon_star-full.svg';
import starTransparent from 'four-nets/icons/svg/icon_star-outlined.svg';

import SVGIcon from 'lib/images/svg-icon/svg-icon';
import Styled from 'styled';

import defaultStyles from './stars-view.scss';

export interface Props {
    styles: typeof defaultStyles;
    rating?: number;
}

@observer
class StarsView extends React.Component<Props> {
    roundHalf = (num: number) => {
        return Math.round(num * 2) / 2;
    };

    stars = (count: number, starType: string) => {
        const { styles } = this.props;

        const tmp = [];
        for (let i = 0; i < count; i++) {
            tmp.push(<SVGIcon style={{ image: styles.star }} key={`star_${i}`} src={starType} />);
        }
        return tmp;
    };

    starCounts = (value: number) => {
        const floatValue = parseFloat(String(value)) || 0;

        let fullStars = Math.floor(floatValue);
        let halfStars = 0;
        const decimal = this.roundHalf(floatValue - fullStars);
        if (decimal > 0) {
            if (decimal > 0.5) {
                fullStars += 1;
            } else {
                halfStars += 1;
            }
        }
        const emptyStars = 5 - halfStars - fullStars;

        return { fullStars, halfStars, emptyStars };
    };

    render() {
        const { rating = 5 } = this.props;
        const styles = this.props.styles!;

        const { fullStars, halfStars, emptyStars } = this.starCounts(rating);

        const fullStarsViews = this.stars(fullStars, star);
        const halfStarView = this.stars(halfStars, star);
        const emptyStarsViews = this.stars(emptyStars, starTransparent);

        return (
            <div className={styles.starsWrapper}>
                {fullStarsViews}
                {halfStarView}
                {emptyStarsViews}
            </div>
        );
    }
}

export default Styled(defaultStyles)(StarsView);
